import {
  IsString,
  IsOptional,
  IsNotEmpty,
  IsIn,
  IsNumber,
} from 'class-validator';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

import { BannerSimple } from './banners-simple.dto';

export class Banner extends BannerSimple {
  @IsNumber()
  @IsNotEmpty()
  id?: number;

  @IsString()
  @IsOptional()
  image?: FileInputValue & { id?: string };

  @IsString()
  @IsOptional()
  title?: string;

  @IsString()
  @IsOptional()
  text?: string;

  @IsString()
  @IsOptional()
  caption?: string;

  @IsString()
  @IsIn(['black', 'white'])
  @IsNotEmpty()
  textColor?: 'black' | 'white';

  @IsString()
  @IsIn(['primary', 'secondary', 'link'])
  @IsNotEmpty()
  buttonType?: 'primary' | 'secondary' | 'link';

  @IsString()
  @IsNotEmpty()
  buttonText?: string;
}
